module.exports = __webpack_public_path__ + "img/SAAB-SCANIA.638db1bd.svg";